//import React from 'react'

const DEBUG = false

export function floatToPercent(number, precision = 2) {
    return (String)((number * 100).toFixed(precision)) + ' %'
}

function getVstParAn(prime_unique, periodicite = 'mensuel', cotisation = 0) {
    return prime_unique === 'oui' ?
            0 :
            periodicite === 'annuel' ?
            cotisation * 12 :
            cotisation
}
export function getVstBrut(prime_unique, periodicite = 'mensuel', cotisation = 0, duree = 1) {
    return getVstParAn(prime_unique, periodicite, cotisation) * duree
}

export function calcul(situation, periodicite, premier_versement, prime_unique, versement_libre, cotisation, 
        rendement, duree, FRAIS_VST, PART_UC, FRAIS_GESTION, VALEUR_UC, RENDEMENT_FONDS_GARANTIS) {
        
    DEBUG && console.log('situation: '+ situation, ', periodicite: ' + periodicite, ', premier_versement: ' + premier_versement, 
    ', prime_unique: ' + prime_unique, ', versement_libre: ' + versement_libre + ', cotisation: ' + cotisation, 
    ', rendement: ' + rendement, ', duree:' + duree, ', FRAIS_VST: ' + FRAIS_VST, ', PART_UC:' + PART_UC, 
    ', FRAIS_GESTION: ' + FRAIS_GESTION, ', VALEUR_UC: ' + VALEUR_UC, ', RENDEMENT_FONDS_GARANTIS: ' + RENDEMENT_FONDS_GARANTIS)
    
        /* Calcul "Epargne atteinte par fonds garanti" */
    const nbJourPeriode = periodicite === 'annuel' ? 365 : 365 / 12
    const cotisationPeriodique = periodicite === 'annuel' ? cotisation * 12 : cotisation
    var pmNetteParVersement, pmNetteTotale = 0

    var cpt = periodicite === 'annuel' ? duree : duree * 12

    var capitalNet = cotisationPeriodique * (1 - PART_UC) * (1 - FRAIS_VST)
    
    for (cpt; cpt > 0; cpt--) {

        pmNetteParVersement = capitalNet * Math.pow(1 + RENDEMENT_FONDS_GARANTIS, nbJourPeriode * cpt / 365)
        pmNetteTotale += pmNetteParVersement

    }
    if (prime_unique === 'oui') { // écrase le calcul réalisé dans le for
        pmNetteTotale = versement_libre * (1 - PART_UC) * (1 - FRAIS_VST)  
                * Math.pow(1 + RENDEMENT_FONDS_GARANTIS, duree)
    }
    
        /* Calcul "Epargne atteinte par UC" */
    const premierVstExplode = premier_versement.split('/')
    const dateDebut = new Date(premierVstExplode[2], premierVstExplode[1] - 1, premierVstExplode[0])
    const nbJourDebut = Math.ceil((new Date(dateDebut.getFullYear(), 11, 31) - dateDebut) / (1000*60*60*24))
    const nbJourFin = 365 - nbJourDebut
    const montantVLP = (prime_unique === 'non') ? cotisationPeriodique * PART_UC : 0
    
    var cptIteration = duree, nbVst = 0, nbJour = 0, partUcRajoutee = 0, vlUc = 0, partUc = 0
    
    for (cptIteration; cptIteration >= 0; cptIteration--) {
        if (cptIteration === duree) { // Première année
            nbVst = periodicite === 'annuel' ? 1 : 12 - dateDebut.getMonth()
            nbJour = nbJourDebut
            vlUc = VALEUR_UC
            partUc = (prime_unique === 'non') ? 
                cotisationPeriodique * PART_UC / VALEUR_UC : 
                versement_libre * PART_UC / VALEUR_UC
        } else if (cptIteration === 0 ){ // Dernière année
            nbVst = periodicite === 'annuel' ? 0 : dateDebut.getMonth()
            nbJour = nbJourFin
        } else { // Année intermédiaire
            nbVst = periodicite === 'annuel' ? 1 : 12
            nbJour = 365
        }
        
        // VL UC
        vlUc = (parseFloat(vlUc) * (1 + rendement * (nbJour / 365))).toFixed(2)
        
        // Part Uc Rajoutée
        partUcRajoutee = (montantVLP / parseFloat(vlUc) * nbVst).toFixed(2)
        
        // Part UC
        partUc = ((parseFloat(partUc) + parseFloat(partUcRajoutee)) * (1 - FRAIS_GESTION)).toFixed(2)
    }
//    const valeurUC = VALEUR_UC * Math.pow(1 + rendement, duree)
    const epargneUC = partUc * vlUc
    
    
        /* Calcul "Epargne contrat classique */
    cpt = periodicite === 'annuel' ? duree : duree * 12
    var capitalNetClassique = cotisationPeriodique * (1 - FRAIS_VST)
    var epargneClassiqueParVst = 0, epargneClassique = 0
    
    for (cpt; cpt > 0; cpt--) {
        epargneClassiqueParVst = capitalNetClassique * Math.pow(1 + RENDEMENT_FONDS_GARANTIS, nbJourPeriode * cpt / 365)
        epargneClassique += epargneClassiqueParVst
    }
    
    if (prime_unique === 'oui') { // écrase le calcul réalisé dans le for
        epargneClassique = versement_libre * (1 - FRAIS_VST)  
                * Math.pow(1 + RENDEMENT_FONDS_GARANTIS, duree)
    }
         
         /* Calcul "Epargne Totale Atteinte" */
    const epargneTotalAtteinte = pmNetteTotale + (cotisationPeriodique * duree * PART_UC)
    
         /* Calcul "Gain Réalisé" */
    const gainRealise = epargneTotalAtteinte - (cotisationPeriodique * duree) * (1 - FRAIS_VST)
    
    return {
        epargneFondsGarantis: Math.floor(pmNetteTotale),
        epargneUC: Math.floor(epargneUC),
        epargneClassique: Math.floor(epargneClassique),
        epargneTotaleAtteinte: Math.floor(epargneTotalAtteinte),
        gainRealise: Math.floor(gainRealise)
    }

}

